import { Input, InputProps, NumberInput, NumberInputField } from '@chakra-ui/react';
import { isNull } from 'lodash';
import { ChangeEvent, FormEvent, MutableRefObject, useEffect, useRef, useState } from 'react';

interface CustomInputProps extends InputProps {disabled?: boolean}

const ControlledInput = (props: CustomInputProps) => {
   const { value, onChange, max, className, placeholder, maxWidth, ...rest } = props;
   const [cursor, setCursor] = useState<number | null>(null);
   const ref = useRef(null) as unknown as MutableRefObject<HTMLInputElement>;

   useEffect(() => {
      const input = ref.current;
      if (input && !isNull(cursor)) {
         if(String(value).slice(-1) === "-") input.setSelectionRange(cursor + 1, cursor + 1)
         else input.setSelectionRange(cursor, cursor);
      };
   }, [ref, cursor, value]);

   const handleChange = (event: ChangeEvent<HTMLInputElement | any>) => {
      setCursor(event.target.selectionStart);
      onChange && onChange(event);
   };
   if(rest.type === "number") {
      return (
         <NumberInput value={value as number} maxWidth={maxWidth ? maxWidth : "300px"} width={"auto"}>
            <NumberInputField max={max || 9999} className={className} placeholder={placeholder} ref={ref} value={value} onChange={handleChange} disabled={rest?.disabled ? rest?.disabled : false} />
         </NumberInput>
      );
   }
   return <Input ref={ref} value={value} className={className} placeholder={placeholder} onChange={handleChange} {...rest} />;
};

export default ControlledInput;
